export default "__VITE_ASSET__CWUB4NLF__"